import { Type } from 'class-transformer'
import { EnumEntity } from '..'
import { PurchaseOrder } from '@/entities/purchase'

export class TransferType extends EnumEntity {
    @Type(() => PurchaseOrder)
    purchaseOrder: PurchaseOrder;
}
